import { Controller } from '@hotwired/stimulus';
import { Offcanvas } from 'bootstrap';

// Ce controller ne pre-cree PAS l'instance Offcanvas.
// Bootstrap la cree a la demande via data-bs-toggle (event delegation sur document).
// Le role du controller est uniquement de nettoyer lors de la navigation Turbo.
export default class extends Controller {
  connect() {
    // Reinitialiser l'etat de l'element (Turbo cache peut restaurer un offcanvas avec class "show")
    this.element.classList.remove('show', 'showing', 'hiding');
    this._cleanup();
  }

  disconnect() {
    // Disposer l'instance Bootstrap si elle existe (creee par data-bs-toggle)
    try {
      const instance = Offcanvas.getInstance(this.element);
      if (instance) instance.dispose();
    } catch (_) {
      // Peut echouer si le DOM a deja ete modifie par Turbo
    }

    this._cleanup();
  }

  _cleanup() {
    document.querySelectorAll('.offcanvas-backdrop').forEach(el => el.remove());
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }
}
